import { environment } from '@/environments/environment'
export default [
  { name: 'getCarrierConfiguration', url: `${environment.puconApiUrl}/carriers/{carrier_code}/services/ecommerce`, method: 'get'},
  { name: 'setCarrierConfiguration', url: `${environment.puconApiUrl}/carriers/{carrier_code}/services/ecommerce`, method: 'put'},
  { name: 'getCarrierTimeLimits', url: `${environment.puconApiUrl}/carriers-time-limits`, method: 'get'},
  { name: 'postPickupsEvaluations', url: `${environment.puconApiUrl}/shippers/{shipper_id}/pickups/{identifier}/evaluations`, method: 'post'}
]
